import React from "react";
import {
  Card,
  CardContent,
  Stack,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Chip,
  Button,
} from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Shield, CheckCircle } from "react-feather";
import { SectionTitle } from "./UiBits";

const getPrioritaColor = (priorita) => {
  switch (priorita) {
    case "alta":
      return "error";
    case "media":
      return "warning";
    case "bassa":
      return "success";
    default:
      return "default";
  }
};

const getPrioritaLabel = (priorita) => {
  switch (priorita) {
    case "alta":
      return "Priorità alta";
    case "media":
      return "Priorità media";
    case "bassa":
      return "Priorità bassa";
    default:
      return priorita;
  }
};

export default function CopertureAssicurativeCard({
  theme,
  cardSx,
  contentSx,
  items,
  expanded,
  onExpandedChange,
  onCreaPreventivo, // opzionale
}) {
  const handleAccordionChange = (panel) => (event, isExpanded) => {
    onExpandedChange(isExpanded ? panel : false);
  };

  return (
    <Card sx={cardSx}>
      <CardContent sx={contentSx}>
        <SectionTitle
          icon={<Shield size={20} />}
          title="Coperture Assicurative Suggerite"
        />

        <Stack spacing={0} divider={<Divider />}>
          {items.map((copertura, index) => (
            <Accordion
              key={index}
              expanded={expanded === `panel${index}`}
              onChange={handleAccordionChange(`panel${index}`)}
              disableGutters
              sx={{
                boxShadow: "none",
                border: "none",
                "&:before": { display: "none" },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  px: 2,
                  py: 0.5,
                  "& .MuiAccordionSummary-content": {
                    my: 1.25,
                    alignItems: "center",
                  },
                }}
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  spacing={2}
                  sx={{ width: "100%" }}
                >
                  <Stack direction="row" alignItems="center" spacing={1.25}>
                    <CircleIcon sx={{ fontSize: 8, color: "primary.main" }} />
                    <Typography sx={{ fontWeight: 700, fontSize: 14 }}>
                      {copertura.tipo}
                    </Typography>
                  </Stack>

                  <Stack direction="row" alignItems="center" spacing={1.25}>
                    <Chip
                      label={getPrioritaLabel(copertura.priorita)}
                      color={getPrioritaColor(copertura.priorita)}
                      size="small"
                    />
                    <Typography sx={{ fontWeight: 800, fontSize: 14 }}>
                      €{copertura.importo.toLocaleString("it-IT")}
                    </Typography>
                  </Stack>
                </Stack>
              </AccordionSummary>

              <AccordionDetails sx={{ px: 2, pt: 0, pb: 2 }}>
                <Stack spacing={1.75}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontSize: 13.5 }}
                  >
                    {copertura.descrizione}
                  </Typography>

                  <Card
                    sx={{
                      bgcolor:
                        theme.palette.mode === "dark" ? "grey.900" : "grey.50",
                      boxShadow: "none",
                      border: `1px solid ${theme.palette.divider}`,
                    }}
                  >
                    <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                      >
                        <Stack
                          direction="row"
                          alignItems="center"
                          spacing={1.5}
                        >
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ fontSize: 12 }}
                          >
                            Massimale stimato
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{ fontWeight: 800, fontSize: 14 }}
                          >
                            {copertura.massimoStimato}
                          </Typography>
                        </Stack>

                        <Button
                          variant="contained"
                          size="small"
                          startIcon={<CheckCircle size={16} />}
                          onClick={() => onCreaPreventivo?.(copertura)}
                          sx={{
                            textTransform: "none",
                            fontSize: 13,
                            fontWeight: 600,
                            py: 0.75,
                            px: 2,
                            flexShrink: 0,
                          }}
                        >
                          Crea Preventivo
                        </Button>
                      </Stack>
                    </CardContent>
                  </Card>
                </Stack>
              </AccordionDetails>
            </Accordion>
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
}
